import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-6" }
const _hoisted_2 = { class: "card-body pt-5 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap justify-content-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Cấu hình website")
], -1)
const _hoisted_5 = { class: "me-0 mb-0 text-end" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_8 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Chung ")
const _hoisted_11 = { class: "nav-item" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Trang chủ ")
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Đại lý ")
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Menu ")
const _hoisted_17 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_18 = { class: "card-body pt-10" }
const _hoisted_19 = { class: "tab-content" }
const _hoisted_20 = {
  class: "tab-pane fade active show",
  id: "tabs_edit_general",
  item: "tabpanel"
}
const _hoisted_21 = { class: "my-5" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-3" }, "Gắn mã Tracking")
], -1)
const _hoisted_24 = { class: "col-md-6 mb-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Header(Trong thẻ Head)", -1)
const _hoisted_26 = { class: "col-md-6 mb-1" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Footer(Chân trang)", -1)
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-3" }, "Thông tin liên hệ")
], -1)
const _hoisted_30 = { class: "col-md-4 mb-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Hotline", -1)
const _hoisted_32 = { class: "col-md-4 mb-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Địa chỉ", -1)
const _hoisted_34 = { class: "col-md-4 mb-1" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Email", -1)
const _hoisted_36 = { class: "col-md-4 mb-1" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Điện thoại", -1)
const _hoisted_38 = { class: "col-md-4 mb-1" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Mã số thuế", -1)
const _hoisted_40 = { class: "col-md-4 mb-1" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Nơi cung cấp", -1)
const _hoisted_42 = { class: "col-md-4 mb-1" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Ngày cung cấp", -1)
const _hoisted_44 = { class: "row mt-5" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-3" }, "Hỗ trợ khách hàng")
], -1)
const _hoisted_46 = { class: "col-md-6 mb-1" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Mail", -1)
const _hoisted_48 = { class: "col-md-4 mb-1" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Điện thoại", -1)
const _hoisted_50 = { class: "row mt-5" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-3" }, "Mạng xã hội")
], -1)
const _hoisted_52 = { class: "col-md-4 mb-1" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Zalo", -1)
const _hoisted_54 = { class: "col-md-4 mb-1" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Facebook", -1)
const _hoisted_56 = { class: "col-md-4 mb-1" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Youtube", -1)
const _hoisted_58 = { class: "row mt-5" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fs-3" }, "Cấu hình popup")
], -1)
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Ảnh Popup", -1)
const _hoisted_62 = { class: "d-flex justify-content-between" }
const _hoisted_63 = { class: "svg-icon svg-icon-2" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_65 = ["src"]
const _hoisted_66 = { class: "col-md-4 mb-1" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Đường dẫn", -1)
const _hoisted_68 = { class: "col-md-2 mb-1" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Hiển thị", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "tabs_edit_seo",
  item: "tabpanel"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column px-9" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row g-9 mb-8" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "add_experience_form",
    model: _ctx.objectData,
    rules: _ctx.rules,
    ref: "formRef",
    class: "form"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  class: "btn-primary btn",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                  loading: _ctx.loading
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", _hoisted_9, [
                _createVNode(_component_router_link, {
                  to: { name: 'general_configs' },
                  class: "nav-link text-active-primary me-6 active"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: { name: 'home_configs' },
                  class: "nav-link text-active-primary me-6"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_13, [
                _createVNode(_component_router_link, {
                  to: { name: 'configs_agency' },
                  class: "nav-link text-active-primary me-6"
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createVNode(_component_router_link, {
                  to: { name: 'configs_menu' },
                  class: "nav-link text-active-primary me-6"
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          rows: "5",
                          modelValue: _ctx.objectData.header_script,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.objectData.header_script) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          rows: "5",
                          modelValue: _ctx.objectData.footer_script,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objectData.footer_script) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          modelValue: _ctx.objectData.hotline,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objectData.hotline) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          modelValue: _ctx.objectData.address,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objectData.address) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.email,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objectData.email) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.phone,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.objectData.phone) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.code_tax,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.objectData.code_tax) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.local_provide,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.objectData.local_provide) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "email"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.date_tax,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.objectData.date_tax) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.customer_support.mail,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objectData.customer_support.mail) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.customer_support.phone,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.objectData.customer_support.phone) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.socials.zalo,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.objectData.socials.zalo) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _hoisted_55,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.socials.facebook,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.objectData.socials.facebook) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _hoisted_57,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.socials.youtube,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.objectData.socials.youtube) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showSingleMedia('popup.image'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_63, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_64
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "image",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"width":"100%"},
                          src: _ctx.renderImageUrl(_ctx.objectData.popup.image, 'medium'),
                          alt: ""
                        }, null, 8, _hoisted_65)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _hoisted_67,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.popup.url,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.objectData.popup.url) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _hoisted_69,
                    _createVNode(_component_el_form_item, {
                      class: "mb-2",
                      prop: "address"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: _ctx.objectData.popup.status,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.objectData.popup.status) = $event)),
                          "active-text": "Hiện",
                          "inactive-text": "Ẩn"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _hoisted_70
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}